var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActsicn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M803.127218 1016.897776l-242.371407-120.865784H191.952012a191.952012 191.952012 0 0 1-191.952012-191.952012v-511.872032a191.952012 191.952012 0 0 1 191.952012-191.952012h639.84004a191.952012 191.952012 0 0 1 191.952012 191.952012v511.872032a192.71982 192.71982 0 0 1-127.968008 180.946763v74.925269a64.431892 64.431892 0 0 1-30.328418 54.578355 65.327668 65.327668 0 0 1-33.655586 9.469633 64.495876 64.495876 0 0 1-28.664834-7.102224zM127.968008 192.207948v511.872032a63.984004 63.984004 0 0 0 63.984004 63.984004h383.904024a61.936516 61.936516 0 0 1 28.60085 6.910272l164.246938 82.091478a109.604599 109.604599 0 0 1 79.916021-91.24119 64.431892 64.431892 0 0 0 47.156211-61.744564v-511.872032a63.984004 63.984004 0 0 0-63.984004-63.984004H191.952012a63.984004 63.984004 0 0 0-63.984004 63.984004z m511.872032 319.92002v-127.968008h127.968008v127.968008z m-191.952012 0v-127.968008h127.968008v127.968008z m-191.952012 0v-127.968008h127.968008v127.968008z",
    fill: "#8F9BB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActsicn);
export default __webpack_public_path__ + "static/media/Actsicn.56b199fdeea7c01b1573079c89af238a.svg";
export { ForwardRef as ReactComponent };